import React from 'react'

import styled from '@emotion/styled'

type Props = {
  image: string
  imageHeight?: string
  children: React.ReactNode
}

const Card = styled.article`
  display: flex;
  flex-direction: column;
  border-radius: 1.5rem;
  box-shadow: ${props => props.theme.dropShadows.tile};
  background: ${props => props.theme.colors.elevatedBackground};
  overflow: hidden;
`

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  height: 12.5rem;
  padding: 1rem;
  background-color: ${props => props.theme.colors.transparentImageBackground};
`

const Image = styled.div<Partial<Props>>`
  height: ${props => props.imageHeight};
  width: 100%;
  background-image: url(${props => props.image});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

const CardContent = styled.div`
  padding: 1.5rem;
`

const ImageCard: React.FC<Props> = ({ image, imageHeight = '100%', children }) => {
  return (
    <Card>
      <ImageContainer>
        <Image image={image} imageHeight={imageHeight} />
      </ImageContainer>
      <CardContent>{children}</CardContent>
    </Card>
  )
}

export default ImageCard
